import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { fetchUserInfo } from "../../auth/authSlice";
import { fetchStudents } from "../../student/studentSlice";

import StudentCapacityBox from "./StudentCapacityBox";
import LogoUploadBox from "./LogoUploadBox";

const AcademyManagementPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserInfo());
    dispatch(fetchStudents());
  }, [dispatch]);

  const { allStudents } = useSelector((state) => state.student);
  const { user } = useSelector((state) => state.auth);

  const textList = [
    {
      keyText: "이용중인 서비스",
      valueText: `${user.plan.toUpperCase()}`,
    },
    {
      keyText: "등록 가능 학생 수",
      valueText: `${user.max_student_capacity}명`,
    },
    {
      keyText: "현재 등록 학생 수",
      valueText: `${allStudents.length}명`,
    },
    {
      keyText: "잔여 등록 학생 수",
      valueText: `${user.max_student_capacity - allStudents.length}명`,
    },
  ];

  return (
    <div
      style={{
        padding: "10px",
        maxWidth: "1400px",
        margin: "0 auto",
      }}
    >
      <h3 style={{ marginRight: "auto", marginBottom: "30px" }}>
        로고 및 카카오채널 관리
      </h3>
      <div
        style={{
          width: "100%",
          backgroundColor: "#FFF",
          height: "calc(100vh - 250px)",
        }}
      >
        <div
          style={{
            fontSize: "18px",
            paddingLeft: "16px",
            paddingTop: "16px",
          }}
        >
          {"학원 로고 변경"}
        </div>
        <LogoUploadBox />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            padding: "0px 20px",
            gap: "30px",
            justifyContent: "center",
          }}
        >
          {textList.map((text, index) => (
            <StudentCapacityBox
              key={index}
              keyText={text.keyText}
              valueText={text.valueText}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AcademyManagementPage;
